import { createContext, useContext, useState } from 'react'
import { Outlet } from 'react-router-dom'

function useCompareMapsContext() {
  const [selectedFieldIds, setSelectedFieldIds] = useState(
    new Map<string, boolean>(),
  )

  return {
    selectedFieldIds,
    setSelectedFieldIds,
  }
}

const CompareMapsContext = createContext(
  {} as ReturnType<typeof useCompareMapsContext>,
)

export const CompareMapsContextProvider = () => {
  const context = useCompareMapsContext()

  return (
    <CompareMapsContext.Provider value={context}>
      <Outlet />
    </CompareMapsContext.Provider>
  )
}

export function useCompareMaps() {
  return useContext(CompareMapsContext)
}
